// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3o5tM","upload":"Small_upload__3R10z","imageWrap":"Small_imageWrap__3o9r7","removeBtn":"Small_removeBtn__2Vv9a"};